import React from "react";

import { FirstText, MiddleDivider, SecondText, StyledButton } from "./style";

export interface ButtonWithAllottedTextProps {
  firstText: string;
  secondText?: string | null | undefined;
  onButtonClick?: Function;
  isDisabled?: boolean;
  isGrayed?: boolean;
}

const ButtonWithAllottedText = ({
  firstText,
  secondText = null,
  onButtonClick,
  isDisabled = false,
  isGrayed = false,
}: ButtonWithAllottedTextProps) => {
  const hasSecondText = !!secondText;

  return (
    <StyledButton
      onClick={() => onButtonClick && onButtonClick()}
      isGrayed={isGrayed}
      disabled={isDisabled}
      between
    >
      <FirstText>{firstText}</FirstText>
      {hasSecondText && <MiddleDivider>{"|"}</MiddleDivider>}
      {hasSecondText && <SecondText>{secondText}</SecondText>}
    </StyledButton>
  );
};

export default ButtonWithAllottedText;
